import type { FixedCharge } from '#api/shared/@types/generated/backend/graphql-schema-types'

export const isFixedCharge = (charge: unknown): charge is FixedCharge =>
  (charge as FixedCharge)?.value !== undefined
